 import { Component, OnInit, OnDestroy, Input,Output, OnChanges,EventEmitter, SimpleChanges, PipeTransform, Pipe, ViewChild, ChangeDetectorRef, ElementRef, HostListener, LOCALE_ID } from '@angular/core';
import { Router, ActivatedRoute, Params, UrlSegment, Event, NavigationStart, NavigationEnd, } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { UsersService } from '../../_services/users.service';
import { SharedFunctionsService } from '../../_services/sharedFunctions.service';
import { IuserInformation } from '../../_types/userInterfaces.type';
import { Location } from '@angular/common';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { UserProfileService } from '../../../_services/user-profile.service';
import { UserProfile } from '../../../_models/user-profile';

declare let $: any;

@Component({

  selector: 'fieldsExpenditures-acl',
  templateUrl: './fieldsExpendituresACL.component.html',
  styleUrls: ['./fieldsExpendituresACL.component.css']

})

export class FieldsExpendituresACLComponent implements OnInit,OnChanges {
  public company: string = "";
  public search: string = "";
  public fieldsOwned : fieldExe[] = [];
  public fieldsAva: fieldExe[] = [];
  public fieldActiveChangeCount: number = 0;
  public loading: boolean = false;
  public selectAllVar: string = "remove";
  public dummbyValue2: any = new Date();
  public dummbyValue1: any = new Date();
  public sortArrayObjAva = {
    fieldName: true,
  }
  public sortArrayObjOwned = {
    fieldName: true,
  }
  public up: UserProfile;
  @Input() public user: IuserInformation;
  @Input() public mode: state;
  @Output() hasChangedTrue: EventEmitter<any> = new EventEmitter();
  @Output() hasChangedFalse: EventEmitter<any> = new EventEmitter();
  @Output() public owed: fieldExe[];



  constructor(private UserService: UsersService,
    private SharedFunctions: SharedFunctionsService,
    private ups: UserProfileService) {
    this.ups.userProfile$.subscribe(result => {
      this.up = result;
    })

  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes.mode != "undefined") {
      this.mode = <state>changes.mode.currentValue;
    }
    else if (typeof changes.user != "undefined") {
      this.user = <IuserInformation>changes.user.currentValue;
     // console.log(this.user)
        this.getFields();
    }
  }

  ngOnInit() {
    if (typeof window != 'undefined') {
      this.company = this.up.currentCompany;
      if (typeof this.user != "undefined" && null != this.user) { 
        this.getFields();
}
    }      
  }

  orderList(columnName: string, list: string) {
    let testarray: any;
    if (list == 'fa') {
      testarray = this.SharedFunctions.sortArray(this.fieldsAva, columnName, this.sortArrayObjAva);
      if (this.sortArrayObjAva[columnName]) {
        this.sortArrayObjAva[columnName] = false;
      } else {
        this.sortArrayObjAva[columnName] = true;
      }
      this.dummbyValue1 = new Date();
    } else {
      testarray = this.SharedFunctions.sortArray(this.fieldsOwned, columnName, this.sortArrayObjOwned);
      if (this.sortArrayObjOwned[columnName]) {
        this.sortArrayObjOwned[columnName] = false;
      } else {
        this.sortArrayObjOwned[columnName] = true;
      }
      this.dummbyValue2 = new Date();
    }
  
  }

  getFields() {
    this.loading = true;
    this.UserService.getFieldsInCompany( this.company)
      .subscribe(result => {
        this.fieldsAva = <fieldExe[]>result;
          this.sortArrayObjAva.fieldName = true;
          this.sortArrayObjOwned.fieldName = true;
        if (this.mode == 1 || this.mode.toString() == "createMode") {
          this.loading = false;

          this.orderList('fieldName', 'fa');
        } else {
          this.getAvaFields();
        }
        
      },
        error => {
          console.log(error);
          this.loading = false;
        });
  }

  refresh() {
    if (this.mode == 0 || this.mode.toString() == "editMode") { 
    this.getFields();
      this.search = "";
    }
  }

  getAvaFields() {
    if (null != this.user.username && "" != this.user.username) { 
      this.UserService.getExpenditureFieldACL(this.user.username, this.company)
        .subscribe(result => {
          this.fieldsOwned = <fieldExe[]>result;
          this.compareFields();
          this.orderList('fieldName', 'fa');
          this.orderList('fieldName', 'fo');
          if (this.fieldsOwned.length > 0) {
            
          }
        },
          error => {
            console.log(error);
            this.loading = false;
          });
    }
  }

  compareFields() {
    this.fieldsOwned.forEach(ava => {     
      this.fieldsAva.forEach((owned,index )=> {
        if (ava.fieldID == owned.fieldID && ava.fieldName == owned.fieldName) {
          this.fieldsAva.splice(index, 1);
        }
      })      
    })
    this.loading = false;
  }

  getFieldIndex(field: fieldExe, fieldList: fieldExe[]): any {
    fieldList.forEach((item, index) => {
      if (item.fieldID == field.fieldID && item.fieldName == field.fieldName) {
        fieldList.splice(index, 1);
        return index;
      }
    })
  }

  changeFieldAssoc(field: fieldExe, value: boolean, index: number) {
    let fieldAssociation: string = "";
    this.hasChangedTrue.next(true);
    if (this.mode == 0 || this.mode.toString() == "editMode") {
      this.fieldActiveChangeCount = this.fieldActiveChangeCount + 1;
      if (field.lockIcon != "spinner-border spinner-border-sm") {
        field.lockIcon = "spinner-border spinner-border-sm"
        if (value) { fieldAssociation = "add"; }
        let test = this.UserService.userExpenditureFieldAssociation({ "UserIDs": [this.user.companyUserID],  "ACLTypeIDs": [field.fieldID] }, String(this.company), fieldAssociation)
          .subscribe(
            result => {

              if (value) {
                index = this.getFieldIndex(field, this.fieldsAva);
                field.lockIcon = "fas fa-minus"
                this.fieldsOwned.push(field);
              }
              else {
                index = this.getFieldIndex(field, this.fieldsOwned);
                field.lockIcon = "fas fa-plus"

                this.fieldsAva.push(field);
              }


              this.fieldActiveChangeCount = this.fieldActiveChangeCount - 1;
              if (this.fieldActiveChangeCount == 0) {               
                this.hasChangedFalse.next(false);
                test.unsubscribe();
              }

            },
            error => {
              console.log(error);
              test.unsubscribe();
              this.fieldActiveChangeCount = this.fieldActiveChangeCount - 1;
              if (this.fieldActiveChangeCount == 0) { this.hasChangedFalse.next(false); }
              if (value) {
                field.lockIcon = "fas fa-plus"
              }
              else {
                field.lockIcon = "fas fa-minus"
              }
            })
      }
    }
    else {
      if (field.lockIcon == "fas fa-plus") {
        this.getFieldIndex(field, this.fieldsAva);       
        field.lockIcon = "fas fa-minus"
        this.fieldsOwned.push(field)
      }
      else {
        this.getFieldIndex(field, this.fieldsOwned);      
        field.lockIcon = "fas fa-plus"
        this.fieldsAva.push(field)
      }

    }
  }

  returnFieldsForCloneUser() {
    return this.fieldsOwned;
  }

  removeAll() {
    if (this.search.trim().length == 0) {
      this.fieldsOwned.forEach((fieldOwned) => { fieldOwned.lockIcon = "fas fa-plus"; })                             
      this.fieldsAva = Object.assign([], this.fieldsAva.concat(this.fieldsOwned));
      this.fieldsOwned = [];
    }
    else {
      let filteredList = this.fieldsOwned.filter((item) => { return item.fieldName.toLowerCase().indexOf(this.search.toLowerCase()) > -1 })
      filteredList.forEach(fo => { fo.lockIcon = "fas fa-plus"; })
      this.fieldsAva = Object.assign([], this.fieldsAva.concat(filteredList));
      let filteredList2 = this.fieldsOwned.filter((item) => { return item.fieldName.toLowerCase().indexOf(this.search.toLowerCase()) == -1 })
      this.fieldsOwned = filteredList2;
    }
  }

  addAll() {
    if (this.search.trim().length == 0) {
       this.fieldsAva.forEach((fieldAva) => { fieldAva.lockIcon = "fas fa-minus"; })                      
       this.fieldsOwned = Object.assign([], this.fieldsOwned.concat(this.fieldsAva));
       this.fieldsAva = [];
    }
    else {
      let filteredList = this.fieldsAva.filter((item) => { return item.fieldName.toLowerCase().indexOf(this.search.toLowerCase()) > -1 })
      filteredList.forEach(fa => { fa.lockIcon = "fas fa-minus"; })
      this.fieldsOwned = Object.assign([], this.fieldsOwned.concat(filteredList));
      let filteredList2 = this.fieldsAva.filter((item) => { return item.fieldName.toLowerCase().indexOf(this.search.toLowerCase()) == -1 })
      this.fieldsAva = filteredList2;
    }
  }

  selectAll() {
    if (this.selectAllVar == "remove" ? this.selectAllVar = "add" : this.selectAllVar = "remove")

      if (this.search.length == 0) {       
        if (this.selectAllVar == "remove") {
        
        }
        else {
          

        }
    }
      else {
        if (this.selectAllVar == "remove") {

        }
        else {

        }
        
    }
  }

}

interface fields {
  fieldID: number;
  fieldName: string;
}

interface fieldExe extends fields {
  lockIcon: string;
}

export enum state {
  cloneMode = 2,
  createMode = 1,
  editMode = 0
}
